import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
     Container, Row, Col,
     Label, Input, InputGroup, CardLink,
     Card, CardImg, CardText, CardBody,
     CardTitle, CardSubtitle, Button, Badge,
     FormFeedback, Modal, ModalHeader, ModalBody, ModalFooter,
     UncontrolledTooltip,
} from 'reactstrap';

import api from '../../../../../api/';
import apifunctions from '../../../../../api/functions.js';
import ParadigmaTable from "../../../../../components/ParadigmaTable/";
import ParadigmaAsyncSeeker from '../../../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker';
import ParadigmaLabeledInput from '../../../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput';
import FormatFunctions from "../../../../../functions/functions";

import InputOffArticulo from './InputOffArticulo.js';

class ArticulosOfertaModalTable extends Component {
     constructor(props) {
          super(props);
          this.refTable = React.createRef();
          this.state = {
               columns: [
                    {
                         Header: "id",
                         id: "id",
                         accessor: "id",
                         show: false,
                         private: true,
                    },
                    {
                         Header: "Categoria_id",
                         id: "Categoria_id",
                         accessor: "Categoria_id",
                         show: false,
                         lookup:"exact",
                         private: true,
                    },
                    {
                         Header: "Codigo",
                         id: "Codigo",
                         accessor: "Codigo",
                         show: true,
                         style:{textAlign:"center"},
                         className:"my-auto",
                         filterable: true,
                         width: 75,
                    },
                    {
                         Header: "Categoria",
                         id: "categoria_nombre",
                         accessor: "categoria_nombre",
                         className:"my-auto",
                         show: true,
                         filterable: true,
                    },
                    {
                         Header: "Titulo",
                         id: "Titulo",
                         accessor: "Titulo",
                         className:"my-auto",
                         show: true,
                         filterable: true,
                    },
                    {
                         Header: "Stock",
                         id: "maxQuantity",
                         accessor: "maxQuantity",
                         show: true,
                         className:"text-center",
                         width:100,
                         filterable: true,
                    },
                    {
                         // Ticket #6145: Se parte del precio de lista para que el descuento que busca aplicarse no se sume al descuento por la condición de pago.
                         Header: "Precio Lista",
                         id: "PrecioLista",
                         accessor: "PrecioLista",
                         className:"text-right",
                         Cell: d => `$ ${FormatFunctions.FormatPrice(d.original.PrecioLista)}`,
                         show: true,
                         width:100,
                    },
                    {
                         Header: "% Descuento",
                         className: "text-center",
                         id: "Descuento",
                         accessor: "Descuento",
                         Cell: d=>{
                              const id = d.original.id;
                              let defaultValue = 0;
                              if(this.props.articulos.filter(elem_id=>id == elem_id.id).length > 0){
                                   defaultValue = this.props.articulos.filter(elem_id=>id == elem_id.id)[0].value;
                              }
                              return (
                                   <InputOffArticulo disabled={this.props.disabled} valueChanged={(val1, val2)=> this.props.ArticulosOfertaChanged(val1, val2)} defaultValue={defaultValue} id={id}/>
                              );
                         },
                         width: 100,
                         sortable:false,
                         filterable:false,
                         show: true,
                    },
                    {
                         Header: "Oferta",
                         id: "Precio",
                         accessor: "Precio",
                         Cell: d=> {
                              const id = d.original.id;
                              let defaultValue = 0;
                              if(this.props.articulos.filter(elem_id=>id == elem_id.id).length > 0){
                                   defaultValue = this.props.articulos.filter(elem_id=>id == elem_id.id)[0].value;
                              }
                              return (
                                    <div className="text-right">{`$ ${FormatFunctions.FormatPrice(d.original.PrecioLista * ( 1 - defaultValue / 100))}`}</div>
                              );
                         },
                         show: true,
                         width:100,
                    },
               ],
               categoria_id:null,
          };
     }
     static propTypes = {
          additionalFields: PropTypes.arrayOf(PropTypes.shape({
               name: PropTypes.string.isRequired,
               onGet: PropTypes.string.isRequired, // (data: data que llega del servidor) => objeto: { key: value } lo que retorna se setea en el estado
               onPost : PropTypes.string.isRequired, // (data: data del estado que se envia al servidor) => objeto: { key: value } lo que se envia al servidor
               Input: PropTypes.func.isRequired, // (state, setThis, disabled, error) => <Input />
          })),
     }

     render() {
          const { data, pages, loading, categoria_id } = this.state;
          const { additionalFields, modernTheme, action, id_item } = this.props;
          const outerFilter = [
               {
                    id: 'id_item',
                    value: id_item,
               }
          ];
          if (categoria_id != undefined && categoria_id != null) {
               outerFilter.push({
                    id: 'Categoria_id',
                    lookup:'exact',
                    value: categoria_id
               });
          }

          return (
               <Container className="p-0">
               <Row className="mb-2">
               <Col className="col-12">
               <Card body className="border-0 p-0 m-0">
               <CardTitle className="text-center py-2 mb-0 col-color">Filtros</CardTitle>
               <CardBody>
               <Row>
               <Col className="col-12">
               <ParadigmaLabeledInput
               label="Categoria"
               md={[3, 9]}
               inputComponent={
                    <ParadigmaAsyncSeeker
                    url={api.gestion.articulos.categorias}
                    value={this.state.categoria_id}
                    displayField="fullName"
                    parameters={{
                         paginationEnabled:false,
                    }}
                    onChange={data => this.setState({categoria_id:data?data.id : null})}
                    />
               }
               />
               </Col>
               </Row>
               </CardBody>
               </Card>
               </Col>
               </Row>
               <ParadigmaTable
               modernTheme={modernTheme}
               buttons={[]}
               apiUrl={api.gestion.articulos.ofertas.articulos}
               columns={this.state.columns}
               defaultPageSize={10}
               title={"Artículos Ofertados"}
               ref={this.refTable}
               innerRef={this.refTable}
               outerFilter={[...outerFilter,]}
               outerSort={[
                    {id: 'Descuento',desc: true},{id: 'categoria_nombre',desc: false},{id: 'Titulo',desc: false},
               ]}
               />
               </Container>
          );
     }
}

export default ArticulosOfertaModalTable;



// WEBPACK FOOTER //
// ./src/views/Gestion/Ventas/Ofertas/ModalOfertas/ArticulosOfertaModalTable.js